import styled from "@emotion/styled";
import { Button } from "@mui/material";
// import React from 'react'
// import theme from "../assets/styles/theme";

export const ContainedButton = styled(Button)(({theme})=>({
  color: theme.palette.background.default,
}));

export const OutlinedButton = styled(Button)(({theme})=>({
  color: theme.palette.secondary.main,
  border: `1px solid ${theme.palette.secondary.main}`,
}));
